import ProducerDetailsData from './ProducerDetailsData';

export default ProducerDetailsData;
